<template>
  <video autoplay="1" poster="images/4k-banner.png" class="w-full h-full" id="lvideo"></video>
  <div v-if="error" class="div"
       style="position: absolute;background:red; color:white;bottom:0;width:100%;padding:20px;z-index: 100">{{
      error
    }}
  </div>
</template>
<script>
var Hls = window.Hls;
export default {
  name: 'pa-stream',
  data() {
    return {
      videoUrl: '',
      error: null
    }
  },
  methods: {
    load() {
      var video = document.getElementById('lvideo');
      var videoSrc = this.$route.params.id;
      if (!videoSrc) {
        videoSrc = localStorage.getItem('stream');
      }
      localStorage.setItem('stream', videoSrc);
      console.log('Video Stream:', videoSrc);
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc;
      } else if (Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
        });

        hls.on(Hls.Events.ERROR, (event, data) => {
          console.log(data);
          console.log(event);
          //if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              // try to recover network error
              this.error = "fatal network error encountered, try to recover";
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              this.error = "fatal media error encountered, try to recover";
              hls.recoverMediaError();
              break;
            default:
              // cannot recover
              this.error = "FATAL ERROR";
              hls.destroy();
              break;
          }
          // }
        });
      }
    },
    pause() {

    },
    seek() {
    },
    seekBack() {
    },
    stopVideo() {
    }
  },
  mounted() {
    window.addEventListener('keydown', (e) => {
      this.code = e.keyCode;
      if (e.keyCode == 19) this.pause();
      if (e.keyCode == 179) this.play();
      if (e.keyCode == 228) this.seek();
      if (e.keyCode == 227) this.seekBack();
      if (e.keyCode == 169) {
        this.$router.go(-1);
      }
    })

    window.addEventListener("online", () => {
      this.load();

    }, false);
    this.load();
  }
}
</script>
